import { resumeDataSchema } from "@resume-studio/schema";
import { z } from "zod/v3";

export const documentSchema = z.object({
  id: z.number().optional(),
  // Stable handle sourced from the WordPress CPT slug. Preferred over `id`
  // for deep-linking, since WP post ids can shift on re-imports.
  slug: z.string().optional(),
  title: z.string().min(1),
  category: z.string().optional(),
  description: z.string().optional(),
  tags: z.array(z.string()).optional(),
  thumbnailUrl: z.string(),
  config: resumeDataSchema,
});

export type ResumeExample = z.infer<typeof documentSchema>;
